
<script setup lang="ts">
import { defineProps,defineEmits } from 'vue'
import { ref,onMounted, onUpdated, watch,onBeforeUnmount } from "vue";

import axios from 'axios'
import { useLanguage } from "../utils/useLanguage";
import { isLogin, checkLoginStatus } from "../utils/useAuth";

const { t } = useLanguage();
const axiosWithToken = axios.create({
  withCredentials: true,  // axios 專用設定，不是 header
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.token ?? ''}`,
  },
});

const userid = ref(localStorage.userId) // Current User ID

/* 
    WebSocket Link
 */

// Get URL for websocket
const link = ref();
const url = location.href // full url
const protocol = location.protocol
const pattern = /^https?:\/\/([^/]+)\//
const match = url.match(pattern)

if (match) {
    const domain = match[1] // domain without protocol
    if(protocol == "http:"){
        link.value = `ws://${domain}/api/v1/chat`
    }else if(protocol == "https:"){
        link.value = `wss://${domain}/api/v1/chat`
    }
} else {
    console.log('No match URL found')
}

type WsStatus = 'connecting' | 'connected' | 'disconnected' | 'failed'
const wsStatus = ref<WsStatus>('connecting')
let reconnectAttempts = 0
const MAX_RECONNECT = 5
let reconnectTimer: ReturnType<typeof setTimeout> | null = null
let isGroupChat = ref(false)
const props = defineProps({  
    user: {
        required: false,
    },
    debate: {
        required: false,
        type: Object,
        default: {

        }
    },
    unread: {
        required: false,
        type: Number,
        default: 0
    }
})
watch(() => props.user, (newVal: any) => {
    console.log('props.user',newVal)
    if (Array.isArray(newVal)) return
    isGroupChat.value = false
    getChatRoom(newVal)
})

/* List All ChatRoom */
const listAllchats:any = ref([]);
function listAllChatRooms(){

    axiosWithToken.get("/api/v1/chat?room_type=Individual&size=100").then((res) => {
        // console.log("listAllChatRooms", res)
        listAllchats.value = [...res.data.data.filter((n: any) => n.room_type == "Individual")]
        // listAllchats.value = [...res.data.data.filter((n: any) => n.room_type == "Group")]
        // console.log("Listallchatroom", listAllchats.value)
        for(let i = 0; i < listAllchats.value.length; i++){
                
            // Partner Details
            for(let j = 0; j < listAllchats.value[i].users.length; j++){
                if(listAllchats.value[i].users[j].user.id !== userid.value){
                    listAllchats.value[i].partner = {id:listAllchats.value[i].users[j].user.id, nick_name:listAllchats.value[i].users[j].user.nick_name, avatar: "/avatar-default.png", user_role: listAllchats.value[i].users[j].user.user_role}

                    let avatar = listAllchats.value[i].users[j].user.avatar

                    // Partner Avatar
                    if(avatar !== null){
                        listAllchats.value[i].partner.avatar = "/api/v1/user/avatar/storage/"+listAllchats.value[i].users[j].user.avatar.file_id
                    }else{
                        listAllchats.value[i].partner.avatar = "/avatar-default.png"
                    }
                }
            }
     
            // Partner Message
            let magArr:any = listAllchats.value[i].messages
            magArr = magArr.sort(function (a:any, b:any) {
                return a.created_at < b.created_at ? 1 : -1;
            });

            
            if(magArr[0] !== undefined){
                listAllchats.value[i].partner.text = magArr[0].text
                listAllchats.value[i].partner.time = timeStr(magArr[0].created_at, 'date')
                
            }else{
                listAllchats.value[i].partner.text = "No Messages"
                listAllchats.value[i].partner.time = ""
            }
            
            // Partner Message Receipts
            let receiptCount = 0
            
            for(let j = 0; j < magArr.length; j++){
                // console.log('magArr',magArr[j])
                if(magArr[j].message_receipts.length == 0 && magArr[j].sender_id !== userid.value){
                    receiptCount = receiptCount + 1;
                }
            }
            listAllchats.value[i].partner.message_receipts = receiptCount

            // console.log('receiptCount',receiptCount)
        }
        console.log('listAllchats後',listAllchats.value)
    })
}
/* Get Each(Current) Chat Room */
const selected = ref(false); 
const currentId = ref(); // Current Partner ID
const currentAlldata:any = ref({
    avatar: '/avatar-default.png',
    roomid: '',
    user_role: '',
    nick_name: '',
    id: '',
    messages: [],
    users: []
});
//partner chata start
let socketPartner: WebSocket
function getChatRoom(partner:any){

    currentAlldata.value.messages = []

    socketPartner = new WebSocket(link.value);
    socketPartner.addEventListener('open', () => {
      console.log('WebSocket取得訊息成功', userid.value, partner.id);
      const request ={
          "command": "CreateChatRoom",
          "request": {
              "room_type": "Individual",
              "user_ids": [userid.value, partner.id]
          }
      }
      socketPartner.send(JSON.stringify(request));
    //   console.log("connect partnerChat")
    })
    
    socketPartner.addEventListener('message', (event) => {
      //console.log('currentAlldata', event.data)
      const resAll = JSON.parse(event.data)
      console.log("socket Partner resAll", resAll)
        sendMsg.value = ""
      
      if(resAll.command == 'CreateChatRoom'){
    
          selected.value = true
          // Current Partner ID
          for(let i = 0; i < resAll.response.users.length; i++){
              if(resAll.response.users[i].user.id !== userid.value){
                  currentId.value = resAll.response.users[i].user.id
              }
          }
    
          // Current Room Message
          let magArr:any = resAll.response.messages
              magArr = magArr.sort(function (a:any, b:any) {
                  return a.created_at < b.created_at ? 1 : -1;
          });
          for(let i = 0; i < magArr.length; i++){
              currentAlldata.value.messages.push(magArr[i])
          }
            
          
          //Send Receipt
          for(let j = 0; j < currentAlldata.value.messages.length; j++){
              if((currentAlldata.value.messages[j].sender_id !== userid.value)&&(currentAlldata.value.messages[j].message_receipts.length == 0)){
                  sendMsgReceipt(currentAlldata.value.messages[j].id)
              }
          }
    
          //Current Room ID
          currentAlldata.value.roomid = resAll.response.id
          currentAlldata.value.id = partner.id
          currentAlldata.value.nick_name = partner.nick_name
          currentAlldata.value.avatar = partner.avatar
          currentAlldata.value.user_role = partner.user_role
        //   currentAlldata.value.users = props.user
          // console.log('currentAlldata', currentAlldata.value)
          getMessageAvatar()
     
      }
      if(resAll.command == "SendMessage"){
                uploadFiles.value = []
                uploadFilesId.value = []
                sendMsg.value = ""
                emojiMenu.value = false

                //listAllChatRooms()

                let newMessage = resAll.response
                if(resAll.response.file_links){

                    newMessage.file_content = []
                    
                    for(let j = 0; j < resAll.response.file_links.length; j++){

                        axios.get("/api/v1/chat/file/storage/" + resAll.response.file_links[j] ).then(function (res) {                        

                            console.log('file_content',res)   
                            if(String(res.headers['content-type']).includes("image/")){
                                newMessage.file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: true
                                })
                            }else if(res.headers['content-type'] == "application/pdf"){
                                newMessage.file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: false
                                })
                            }

                        }).catch(function (res) {
                            console.log('file_links error',res)   

                        })                
                    }
                }
                
                //currentAlldata.value.messages.unshift(newMessage)
      }

      if(resAll.command == 'ReceiveMessageReceipt'){
            for(let i = 0; i < currentAlldata.value.messages.length; i++){
                currentAlldata.value.messages[i]['receipt'] = true
            }
        }

        if(resAll.command == 'ReceiveMessage' && resAll.response?.chat_room_id === currentAlldata.value.roomid){
            //listAllChatRooms()
                currentAlldata.value.messages.unshift(resAll.response)
                getNewMsgAvatar()
                // if (resAll.response.chat_room_id === currentAlldata.value.roomid){
                //     sendMsgReceipt(resAll.response.id)
                // }

            for(let i = 0; i < currentAlldata.value.messages.length; i++){
                if(currentAlldata.value.messages[i].file_links){
                    currentAlldata.value.messages[i]['file_content'] = []

                    for(let j = 0; j < currentAlldata.value.messages[i].file_links.length; j++){

                        axios.get("/api/v1/chat/file/storage/" + currentAlldata.value.messages[i].file_links[j] ).then(function (res) {                        

                            if(String(res.headers['content-type']).includes("image/")){
                                currentAlldata.value.messages[i].file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: true
                                })
                            }else{
                                currentAlldata.value.messages[i].file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: false
                                })
                            }

                        }).catch(function (res) {
                            console.log('file_links error',res)   

                        })                   
                    }
                }
            }
        }
      listAllChatRooms();
      //console.log("currAllData", currentAlldata.value)
    })

}
/* Message Read */
function sendMsgReceipt(msgid: any){
    const request ={
        "command": "SendMessageReceipt",
        "request": {
            "message_id": msgid
        }
        }
        socketPartner.send(JSON.stringify(request));
        console.log("sendmsgReceipt")
}
//get message avatar
let msgUsers: any = []
let msgAvatar: any = []
let msgName: any = []
function getMessageAvatar() {
    console.log("getMessageAvatar",currentAlldata.value)
    for (let user of currentAlldata.value.users) {
        msgUsers.push(user.user.id)
        msgAvatar.push(user.user.avatar)
        msgName.push(user.user.nick_name)
    }
    console.log("new messages", msgAvatar, msgUsers, msgName)
    for (let i = 0; i < currentAlldata.value.messages.length; i++) {
        let index = msgUsers.indexOf(currentAlldata.value.messages[i].sender_id)
        currentAlldata.value.messages[i]["avatar"] = msgAvatar[index]
        currentAlldata.value.messages[i]["nick_name"] = msgName[index]
        //console.log("nick_name", currentAlldata.value.messages[i]["nick_name"], msgName[index], msgAvatar[index], index)
    }
}

function getNewMsgAvatar() {
    //console.log("new msg", currentAlldata.value.messages[0])
    let index = msgUsers.indexOf(currentAlldata.value.messages[0].sender_id)
    currentAlldata.value.messages[0]["avatar"] = msgAvatar[index]
    currentAlldata.value.messages[0]["nick_name"] = msgName[index]
}
//get group chat
function socketMsg(event: any){
    return JSON.parse(event.data);
}
let socketGroup: WebSocket;
let allGroupMsg = ref();
function connectGroupWebSocket() {
    wsStatus.value = 'connecting'
    socketGroup = new WebSocket(link.value)
    socketGroup.addEventListener('open', (event) => {
        console.log('open socket', event)
        wsStatus.value = 'connected'
        reconnectAttempts = 0
        const request = {
            "command": "GetChatRoom",
            "request": {
                "chat_room_id": props.debate.chat_room_id
            }
        }

        socketGroup.send(JSON.stringify(request));
    });

    socketGroup.addEventListener('error', (event) => {
        console.warn('WebSocket error', event)
        wsStatus.value = 'failed'
    });

    socketGroup.addEventListener('close', (event) => {
        console.log('WebSocket Connection Closed', event.code, event.reason);
        // 4401 = backend "unauthorized" close. Don't loop on auth failure.
        if (event.code === 4401) {
            wsStatus.value = 'failed'
            return
        }
        if (reconnectAttempts >= MAX_RECONNECT) {
            wsStatus.value = 'failed'
            return
        }
        wsStatus.value = 'disconnected'
        reconnectAttempts += 1
        const delay = Math.min(30_000, 1_000 * 2 ** reconnectAttempts)
        reconnectTimer = setTimeout(() => {
            reconnectTimer = null
            connectGroupWebSocket()
        }, delay)
    });

    socketGroup.addEventListener('message', (event:any) => {
        let resAll = socketMsg(event);
        allGroupMsg.value = resAll
        console.log('allGroupMsg', allGroupMsg.value)
        console.log('socket Group resAll', resAll)
        if(resAll.command == 'GetChatRoom' && resAll.status !== "failed") {
            currentAlldata.value.messages = []
            selected.value = true
            // const data = JSON.parse(event.data)
            // const resAll = data.response.messages
            console.log("resAll tset", resAll.response.messages)
            //Current Room Message
            let magArr:any = resAll.response.messages
            magArr = magArr.sort(function (a:any, b:any) {
                return a.created_at < b.created_at ? 1 : -1;
            });
            for(let i = 0; i < magArr.length; i++){
                currentAlldata.value.messages.push(magArr[i])
            }
            console.log("magArr", magArr)
            currentAlldata.value.nick_name = props.debate.title_cn//fix me
            currentAlldata.value.roomid = props.debate.chat_room_id//fix me
            currentAlldata.value.title = props.debate.title
            currentAlldata.value.users = props.user
            console.log("currentAlldata", currentAlldata.value, "resAll", resAll)
            getMessageAvatar()
        }
        if(resAll.command == 'ReceiveMessage' && resAll.status !== "failed" && resAll.response?.chat_room_id === props.debate?.chat_room_id){
            //listAllChatRooms()
            currentAlldata.value.messages.unshift(resAll.response)
            getNewMsgAvatar()
            const isOpen = document.getElementById("groupchat")?.classList.contains('open')
            if (resAll.response.sender_id !== userid.value) {
                if (isOpen) {
                    axiosWithToken.post(`/api/v1/chat/${props.debate.chat_room_id}/read`)
                        .catch((error) => console.error('mark read', error))
                } else {
                    emit('update:unread', props.unread + 1)
                }
            }
                // sendMsgReceipt(resAll.response.id)

            for(let i = 0; i < currentAlldata.value.messages.length; i++){
                if(currentAlldata.value.messages[i].file_links){
                    currentAlldata.value.messages[i]['file_content'] = []

                    for(let j = 0; j < currentAlldata.value.messages[i].file_links.length; j++){

                        axios.get("/api/v1/chat/file/storage/" + currentAlldata.value.messages[i].file_links[j] ).then(function (res) {                        

                            if(String(res.headers['content-type']).includes("image/")){
                                currentAlldata.value.messages[i].file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: true
                                })
                            }else{
                                currentAlldata.value.messages[i].file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: false
                                })
                            }

                        }).catch(function (res) {
                            console.log('file_links error',res)   

                        })                   
                    }
                }
            }
        }
        if(resAll.command == "SendMessage" && resAll.status !== "failed"){
                uploadFiles.value = []
                uploadFilesId.value = []
                sendMsg.value = ""
                emojiMenu.value = false

                //listAllChatRooms()

                let newMessage = resAll.response
                if(resAll.response.file_links){

                    newMessage.file_content = []
                    
                    for(let j = 0; j < resAll.response.file_links.length; j++){

                        axios.get("/api/v1/chat/file/storage/" + resAll.response.file_links[j] ).then(function (res) {                        

                            console.log('file_content',res)   
                            if(String(res.headers['content-type']).includes("image/")){
                                newMessage.file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: true
                                })
                            }else if(res.headers['content-type'] == "application/pdf"){
                                newMessage.file_content.push({
                                    id: resAll.response.file_links[j],
                                    type: false
                                })
                            }

                        }).catch(function (res) {
                            console.log('file_links error',res)   

                        })                
                    }
                }
                
                //currentAlldata.value.messages.unshift(newMessage)
      }

    })
}
watch(() => props.debate?.chat_room_id, (chatRoomId: any) => {
    if (!chatRoomId) return
    isGroupChat.value = true;
    connectGroupWebSocket()
}, { immediate: true })
/* Upload Files */
let uploadFiles = ref<any[]>([]);  
let uploadFilesId = ref<any[]>([]);  

const isUploading = ref(false)
const uploadError = ref('')
const handleFileChange = (event: Event, roomId: string) => {
    if(uploadFiles.value.length >= 10){
        alert('You can upload up to 10 files at a time!')
        return
    }
  const target = event.target as HTMLInputElement;
  const files = target.files;

  if (files) {
    const uploadedFile: any = files[0];

    isUploading.value = true
    uploadError.value = '' 

    var formData = new FormData();

    formData.append("file", uploadedFile);
    formData.append("chat_room_id", roomId);

    axiosWithToken
        .post("/api/v1/chat/file", formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then(function (res) {
            uploadFiles.value.push(res.data);
            uploadFilesId.value.push(res.data.file.file_id);
            isUploading.value = false
        })
        .catch(function (res) {
            console.log("uploaded error", res);
            isUploading.value = false
            uploadError.value = 'File upload failed. Please make sure the file name does not contain Chinese characters or special characters, then try again.'
            console.log("uploadError:", uploadError.value)
        });
  }
//   console.log('upload Files', uploadFiles.value);
};

const deleteFile = (index: any) =>{
    uploadFiles.value.splice(index, 1);
    uploadFilesId.value.splice(index, 1);
}

/* Send Message */
const sendMsg = ref("")
function sendMessage(roomId: string){
    console.log('sendMessage isGroupChat', isGroupChat.value);
    let sendText = ""
    if(sendMsg.value == ""){
        sendText = "(The files has been sent)"
    }else{
        sendText = sendMsg.value
    }

    const request ={
            "command": "SendMessage",
            "request": {
                    "chat_room_id": roomId,
                    "text": sendText,
                    "file_links": uploadFilesId.value
            }
        }
    const socket = isGroupChat.value ? socketGroup : socketPartner
    if (socket?.readyState !== WebSocket.OPEN) return
    socket.send(JSON.stringify(request));
    uploadFiles.value = []
    uploadFilesId.value = []
    sendMsg.value = ""
    emojiMenu.value = false
}

const emit = defineEmits(['update:debate', 'update:unread'])

const close = () => {
    
    const groupchat: HTMLDivElement = document.getElementById("groupchat") as HTMLDivElement;
    groupchat.classList.remove('open')
    const videoBox: HTMLDivElement = document.getElementById("videobox") as HTMLDivElement;

    if(videoBox){
        videoBox.classList.add('open')
    }
}

/* Emoji  */
interface Emoji {
  id: number;
  symbol: string;
}

let emojiMenu = ref(false)
const emojis: Emoji[] = [
  { id: 1, symbol: '😊' },
  { id: 2, symbol: '😃' },
  { id: 3, symbol: '😍' },
  { id: 4, symbol: '🥰' },
  { id: 5, symbol: '😆' },
  { id: 6, symbol: '😎' },
  { id: 7, symbol: '🤩' },
  { id: 8, symbol: '😘' },
  { id: 9, symbol: '😁' },
  { id: 10, symbol: '🤗' },
  { id: 11, symbol: '🙂' },
  { id: 12, symbol: '😉' },
  { id: 13, symbol: '😜' },
  { id: 14, symbol: '🤪' },
  { id: 15, symbol: '😂' },
  { id: 16, symbol: '🤣' },
  { id: 17, symbol: '😇' },
  { id: 18, symbol: '😋' },
  { id: 19, symbol: '😛' },
  { id: 20, symbol: '😴' },
  { id: 21, symbol: '🤔' },
  { id: 22, symbol: '🙄' },
  { id: 23, symbol: '😮' },
  { id: 24, symbol: '🤐' },
  { id: 25, symbol: '😷' },
  { id: 26, symbol: '🤕' },
  { id: 27, symbol: '🥳' },
  { id: 28, symbol: '🤠' },
  { id: 29, symbol: '😤' },
  { id: 30, symbol: '🤬' },
  { id: 31, symbol: '🤯' },
  { id: 32, symbol: '😱' },
  { id: 33, symbol: '😢' },
  { id: 34, symbol: '😭' },
  { id: 35, symbol: '😩' },
  { id: 36, symbol: '😠' },
  { id: 37, symbol: '🥺' },
  { id: 38, symbol: '😓' },
  { id: 39, symbol: '🙃' },
  { id: 40, symbol: '🤑' },
  { id: 41, symbol: '🤡' },
  { id: 42, symbol: '🤫' },
  { id: 43, symbol: '🤥' },
  { id: 44, symbol: '🤢' },
  { id: 45, symbol: '🤮' },
  { id: 46, symbol: '😳' },
  { id: 47, symbol: '🥱' },
  { id: 48, symbol: '😴' },
  { id: 49, symbol: '🤤' },
  { id: 50, symbol: '🙈' },
  { id: 51, symbol: '❤️' },
  { id: 52, symbol: '💗' },
  { id: 53, symbol: '💖' },
  { id: 54, symbol: '💛' },
  { id: 55, symbol: '💙' },
  { id: 56, symbol: '💚' },
  { id: 57, symbol: '💜' },
  { id: 58, symbol: '💕' },
  { id: 59, symbol: '⭐️' },
  { id: 60, symbol: '✨' }
]

function insertEmoji(emoji: Emoji): void {
    sendMsg.value += emoji.symbol;
}

function timeStr(date:any, type:any){
    let zone = new Date().getTimezoneOffset() // jet lag
    let local = new Date(date).getTime() - zone * 60 * 1000 // local time in ms
    let posttime = new Date(local) // display time

    if(type == "date"){        
        return posttime.getFullYear() + '/' + (posttime.getMonth() + 1) + '/' + posttime.getDate() + ' ' + (posttime.getHours()<10?'0':'') + posttime.getHours() + ':' + (posttime.getMinutes()<10?'0':'')+ posttime.getMinutes()
    }else{
        return (posttime.getHours()<10?'0':'') + posttime.getHours() + ':' + (posttime.getMinutes()<10?'0':'')+ posttime.getMinutes();
    }
}

onMounted(() => {
    checkLoginStatus()
    if(isLogin){
        listAllChatRooms();
    }
});

onBeforeUnmount(() => {
    if (reconnectTimer) {
        clearTimeout(reconnectTimer)
        reconnectTimer = null
    }
    reconnectAttempts = MAX_RECONNECT
    try { socketGroup?.close(1000, 'unmount') } catch {}
    try { socketPartner?.close(1000, 'unmount') } catch {}
});

</script>

<template>
    <main class="chatBox group fixed">
        <div class="msgTitle title-3 bg-dark white bold flex j-between">{{ t('Group Chat')}}<div class="icon-close white sm pointer" @click="close"></div></div>
        <div v-if="wsStatus !== 'connected'" class="ws-status-banner font-4" :class="wsStatus">
            <span v-if="wsStatus === 'connecting'">{{ t('Connecting…') }}</span>
            <span v-else-if="wsStatus === 'disconnected'">{{ t('Connection lost — reconnecting…') }}</span>
            <span v-else>{{ t('Connection failed') }}</span>
        </div>

        <div class=" bg-white-2 flex flex-col-2 column-sm" style="height: calc(100% - 40px)"> 
    
            <div class="bg-white-3 p-20 rel msgMain" v-if="currentAlldata">
                <div class="flex a-center gap-10 abs msgTitle bg-white-3"  style="top: 0; left: 0; right: 0; padding: 10px">
                    <div class="db_dp rel i-flex a-center gap-10">
                        <span class="icon-people lg"></span>
                        <div class="db_dpc abs">
                            <div class="db_avatar" v-for="(user, index) in currentAlldata.users" :key="index">
                                <img :src="user.user.avatar ? '/api/v1/user/avatar/storage/' + user.user.avatar.file_id :'/avatar-default.png'" alt="">
                                {{ user.user.nick_name }}
                            </div>
                        </div>
                        ▾                    
                    </div>
                    <h4 class="font-2 bold">{{ currentAlldata.room_name }}</h4>                        
                    <div class="bold ">{{t('Talk Topic')}}: {{ currentAlldata.title }}</div>
                </div>
              
             
             
                <div class="flex reverse gap-10 scroll msgContent bg-white-3">
                    <div  v-for="(msg, index) in currentAlldata.messages" :key="index" >
                        <div class="flex a-center gap-5" :class="[msg.sender_id == userid ? 'f-reverse': '']">
                            <div class="d_avatar" v-if="msg.sender_id !== userid">
                                <img :src="msg.avatar ? '/api/v1/user/avatar/storage/' + msg.avatar.file_id :'/avatar-default.png'" alt="">
                                <span class="font-4 namePadding">{{ msg.nick_name }}</span>
                            </div>
                            <div class="font-4 msg" :class="[msg.sender_id == userid ? 'bg-white-4': 'bg-light-pr']" v-if="msg.text">{{ msg.text }}</div>
                            <div class="font-4 black-4">{{ timeStr(msg.created_at, 'time')}} </div>
                            <!-- <div class="font-4" :class="[msg.message_receipts.length > 0 || msg.receipt ? 'light-grey': 'black-4']" v-if="msg.sender_id == userid && !isGroupChat">{{ msg.message_receipts.length > 0 || msg.receipt? 'Read':'Unread' }} </div> -->
                        </div>
                        <div v-if="msg.file_links && msg.file_links.length > 0" class="font-4 flex black-4 mt-10" :class="[msg.sender_id == userid ? 'f-reverse': '']">{{msg.sender_id !== userid ? currentAlldata.nick_name + ` has sent the following files to you:`: `You have sent the files to `+ currentAlldata.nick_name}}</div>
                        <div class="fileslist i-grid g-col-2 gap-5 mb-10 mt-10" :class="[msg.sender_id == userid ? 'f-right': '']" style="max-width: 350px" v-if="msg.file_links && msg.file_links.length > 0">
                            <a :href="'/api/v1/chat/file/storage/'+ file"  v-for="(file, index) in msg.file_links" :key="index">
                                <img class="fileImg" :src="'/api/v1/chat/file/storage/'+ file" onerror="this.src='/icon-file.png'" alt="">
                            </a>
                        </div> 
                        <div v-if="msg.file_links && msg.file_links.length > 0" class="font-4 flex black-4" :class="[msg.sender_id == userid ? 'f-reverse': '']">{{ `A total of `+ msg.file_links.length+ ` files`  }}</div>
                    </div>
                </div>
                
                <div class="abs" style="bottom: 0; left: 0; right: 0; padding: 10px; width: 100%;">
                    <div v-if="isUploading" class="font-4 black-3 mb-5">
                        File uploading, please wait...
                    </div>
                    <div v-if="uploadError" class="font-4 upload-error mb-5">
                        {{ uploadError }}
                    </div>
                    <div class="fileItem bg-white flex j-between a-center font-4" v-for="(file, index) in uploadFiles" :key="index">
                        {{ file.file.filename }}
                        <span class="icon-close pointer sm" @click="deleteFile(index)"></span>
                    </div>
                    <div class="emojiList flex wrap gap-5 bg-white" :class="emojiMenu ? 'active': ''">
                        <div class="emoji font-4 pointer" v-for="emoji in emojis" :key="emoji.id" @click="insertEmoji(emoji)">
                            {{ emoji.symbol }}
                        </div>
                    </div>
                    <div class="flex a-center gap-5">

                        <div class="bg-white flex a-center j-between gap-5" style="width: 100%; padding: 10px;">
                            <span class="icon-mood-smile md pointer emojiBtn" @click="emojiMenu = !emojiMenu" :class="emojiMenu ? 'bg-black-4 white': 'black-3'"></span>
                            <input type="text" :placeholder="t('Enter reply')" style="width: 100%;" v-model="sendMsg" :disabled="!selected" @keyup.enter="sendMessage(currentAlldata.roomid)">
                            
                            
                            <label for="fileUpload">
                                <input type="file" hidden id="fileUpload"  @change="handleFileChange($event, currentAlldata.roomid)">
                                <span class="icon-docs md black-3 pointer"></span>
                            </label>
                           
                        </div>
                        <img class="send pointer" @click="sendMessage(currentAlldata.roomid)" src="/icon-send.png" alt="" :class="[!selected || ((sendMsg == '') && (uploadFiles.length == 0))? 'disabled':'']">
                    </div>
                </div>
                
            </div>
            <div class="p-40 flex j-center a-center bg-white-4" v-else>
                <p class="font-3 lh-15 black-3">Please click your contact to send or review messages here.</p>
            </div>
        </div>
   

    </main>

</template>
<style scoped>
@import '../assets/styles/dashboard.css';

.ws-status-banner{
    padding: 6px 12px;
    text-align: center;
    color: #fff;
}
.ws-status-banner.connecting{ background: #6c757d; }
.ws-status-banner.disconnected{ background: #f0ad4e; }
.ws-status-banner.failed{ background: #d9534f; }

.upload-error {
    color: #d9534f;
    padding: 6px 8px;
    background: #fff5f5;
    border-radius: 4px;
}

.fileItem{
    border: .5px solid #BDBDBD;
    padding: 3px 8px;
}
.fileslist::-webkit-scrollbar{ 
    height: 0px;
}

.emojiList{
    display: none;
    padding: 3px 8px;
    border: .5px solid #BDBDBD;
    border-radius: 3px;
}
.emojiList.active{
    display: flex;
}
.emojiBtn{
    border-radius: 3px;
    padding: 1px;
}
.fileImg{
    width: 70px;
    height: 70px;
    object-fit: cover;
}

.half {
    width: 50%;
}
.namePadding {
    padding: 2px;
}
.db_dp:hover > .db_dpc{
    opacity: 1;
}
.db_dp:not(:hover) > .db_dpc{
    pointer-events: none;
}
.db_dpc{
    opacity: 0;
    transition: all .5s;
    padding: 10px;
    background-color: #f3f3f3;
    top: 25px;
    left: 0;
    font-size: 13px;
    font-weight: bold;
    white-space: pre;
    z-index: 99;
}
/* Avatar */
.db_avatar{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    gap: 5px;
}
.db_avatar > img{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
}
</style>